import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center px-6 md:px-12 max-w-7xl mx-auto w-full pt-20 pb-12" data-id="element-105">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center content-relative" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-start order-2 lg:order-1" data-id="element-107">
          <div className="flex items-center gap-4 mb-8" data-id="element-108">
            <div className="h-[1px] w-8 bg-blood" data-id="element-109"></div>
            <span className="text-blood font-sans text-xs font-bold tracking-widest uppercase" data-id="element-110">
              Filosofía Prohibida · Manual Estratégico
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-foreground" data-id="element-111">
            Deja de ser la marioneta de los juegos de poder de los demás.
          </h1>

          <p className="text-lg md:text-xl text-foreground/70 font-sans font-light leading-relaxed mb-10 max-w-xl" data-id="element-112">
            El manual estratégico para detectar hilos de manipulación, integrar
            tu psicología de sombra y recuperar tu soberanía personal en un
            mundo de lobos.
          </p>

          <div className="w-full sm:w-auto flex flex-col gap-4" data-id="element-113">
            <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-114">
              Haz clic aquí para descargar el código de la sombra
            </Button>
            <p className="text-xs text-foreground/50 font-sans text-center sm:text-left" data-id="element-115">
              Acceso instantáneo. Formato PDF compatible con todos los
              dispositivos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1],
        delay: 0.2
      }} className="relative order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-116">
          <div className="relative w-full max-w-md lg:max-w-lg aspect-[3/4]" data-id="element-117">
            <div className="absolute inset-0 bg-blood/10 blur-3xl rounded-full mix-blend-screen" data-id="element-118"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1v429QUCXG7knebdAxGr6K/heylloyd-image-1778192138202.png" alt="El Código de la Sombra eBook" width={1456} height={770} loading="eager" decoding="async" fetchPriority="high" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-119" />
          </div>
        </motion.div>
      </div>
    </section>;
}